export default __webpack_public_path__ + "static/media/Cardona.e5a6985a.jpg";